import Wrapper from '../components/Wrapper'

const Error = () => {
  return <Wrapper>Something went wrong!</Wrapper>
}

export default Error
